module.exports = __webpack_public_path__ + "img/RX-Arcos-2.989dd995.png";